import React from 'react';
import { Layout } from 'antd';
const { Footer } = Layout;
import { color, VERSION } from '../../../../resources';

const FooterLayout = () => {
  return (
    <Footer style={{ textAlign: 'center', backgroundColor: color.black_why, color: color.white }}>
      ZettaSoft @2025 version {VERSION}
    </Footer>
  );
};

export default FooterLayout;
